import store from './store/index'
import { qiniuImageURLPrefix } from '@/config/config'
import { uploadImage64 } from '@/assets/js/upload'

export function windowInit() {
	// 身份证拍照
	window.getBase64ImgFromAndroidIdcard = function(str1, str2) {
		store.commit('SET_FORM_IMG', { 
			type: 'legal_representative_card_front',
			imgStr: str1.split(qiniuImageURLPrefix)[1],
		})
		
		store.commit('SET_FORM_IMG', {
			type: 'legal_representative_card_backend',
			imgStr: str2.split(qiniuImageURLPrefix)[1],
		})
	}

	// 活体认证
	window.getLivenessImage = async (str) =>  {
		const url = await uploadImage64(str)
		store.commit('SET_FORM_IMG', {
			type: 'living_image',
			imgStr: url,
		})
	}

	// 身份证
	window.getBase64ImgFromAndroidBankcard = function(str1, str2) {
		store.commit('SET_FORM_IMG', { 
			type: 'bank_card_front',
			imgStr: str1.split(qiniuImageURLPrefix)[1],
		})
		
		store.commit('SET_FORM_IMG', {
			type: 'bank_card_backend',
			imgStr: str2.split(qiniuImageURLPrefix)[1],
		})
	}
	// 安卓拍照
	window.getBase64ImgFromAndroidCharter  = function (str, type ) {
		store.commit('SET_FORM_IMG', {
			imgStr: str.split(qiniuImageURLPrefix)[1],
			type: type
		})
	}
	// 键盘收起事件
	window.checkoutKeyBoradEvent = function() {
		this.document.body.focus()
	}
}
